export const findNodeById = (nodes: any[], id: string | number): any | undefined => {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.filhos) {
      const children = node.filhos;
      const found = findNodeById(children, id);
      if (found) return found;
    }
  }
  return undefined;
};
